module.exports = __webpack_public_path__ + "img/speaker4.png?e768f6167c4fdf29def3f991be06172e";